import { AxiosRequestConfig } from 'axios'
import { Generator, GeneratorInput, GeneratorQuery } from '../types'
import createAPIClient from '../services/apiClient'

const api = createAPIClient('v2')

export async function getGenerators(
  query: GeneratorQuery = {},
  config?: Omit<AxiosRequestConfig, 'params'>
): Promise<Generator[]> {
  const response = await api.get(`/generators`, {
    params: query,
    ...config
  })

  return response.data
}

export async function createGenerator(
  input: GeneratorInput,
  config?: AxiosRequestConfig
): Promise<Generator> {
  const response = await api.post(`/generators`, input, config)

  return response.data
}

export async function getGenerator(id: string, config?: AxiosRequestConfig): Promise<Generator> {
  const response = await api.get(`/generators/${id}`, config)

  return response.data
}

type UpdateGeneratorInput = Partial<GeneratorInput>

export async function updateGenerator(
  id: string,
  input: UpdateGeneratorInput,
  config?: AxiosRequestConfig
): Promise<Generator> {
  const response = await api.patch(`/generators/${id}`, input, config)

  return response.data
}

export async function deleteGenerator(id: string, config?: AxiosRequestConfig): Promise<void> {
  await api.delete(`/generators/${id}`, config)
}
